var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21875 0.5C1.11414 0.5 0.21875 1.39551 0.21875 2.5V16.5C0.21875 17.6045 1.11414 18.5 2.21875 18.5H16.2188C17.3234 18.5 18.2188 17.6045 18.2188 16.5V2.5C18.2188 1.39551 17.3234 0.5 16.2188 0.5H2.21875ZM2.68469 6.89771V15.625H5.1051V6.89771H2.68469ZM2.97449 5.41479C3.23206 5.65332 3.54077 5.77271 3.90051 5.77271C4.26038 5.77271 4.56726 5.65332 4.82104 5.41479C5.07861 5.17236 5.2074 4.88257 5.2074 4.54541C5.2074 4.21216 5.07861 3.92603 4.82104 3.6875C4.56726 3.44507 4.26038 3.32397 3.90051 3.32397C3.54077 3.32397 3.23206 3.44507 2.97449 3.6875C2.7207 3.92603 2.59375 4.21216 2.59375 4.54541C2.59375 4.88257 2.7207 5.17236 2.97449 5.41479ZM9.46448 15.625V10.5796C9.46826 10.2046 9.53833 9.88452 9.67468 9.61938C9.81482 9.35034 10.0081 9.14575 10.2543 9.00562C10.5043 8.86548 10.7921 8.79541 11.1179 8.79541C11.6028 8.79541 11.9834 8.94702 12.2599 9.25C12.5365 9.54932 12.6729 9.96582 12.6691 10.5V15.625H15.0895V10.0681C15.0895 9.39014 14.9645 8.80688 14.7145 8.31812C14.4645 7.82568 14.1141 7.44702 13.6633 7.18188C13.2126 6.91675 12.6842 6.78418 12.0781 6.78418C11.4304 6.78418 10.8793 6.93359 10.4247 7.23291C9.97021 7.52832 9.64636 7.92993 9.45312 8.4375H9.35083V6.89771H7.04407V15.625H9.46448Z",
    fill: "#B1924C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c3ce7d56309da1427c80214228a2ec84.svg";
export { ForwardRef as ReactComponent };